import React, { ChangeEvent, useState, useEffect } from 'react';
import { styled } from '@material-ui/core/styles';
import { ConnectOptions } from 'twilio-video';

import CircularProgress from '@material-ui/core/CircularProgress';
import LocalVideoPreview from '../components/LocalVideoPreview/LocalVideoPreview';
import './joinRoom.css';

import logoImage from '../images/logo.png';
import { VideoProvider } from '../components/VideoProvider';

import { useAppState } from '../state';
import { Snackbar } from '@material-ui/core';


const connectionOptions: ConnectOptions = {
  bandwidthProfile: {
    video: {
      mode: 'collaboration',
      renderDimensions: {
        high: { height: 1080, width: 1920 },
        standard: { height: 90, width: 160 },
        low: { height: 90, width: 160 },
      },
    },
  },
  dominantSpeaker: true,
  maxAudioBitrate: 12000,
  networkQuality: { local: 1, remote: 1 },
  preferredVideoCodecs: [{ codec: 'VP8', simulcast: true }],
};

const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
});

const Main = styled('main')({
  height: '100%',
  position: 'relative',
});

export default function App() {

  let rommNameArray = window.location.search.match(/URLRoomName=(.*)&?/);
  const URLRoomName = rommNameArray ? rommNameArray[1] : window.sessionStorage.getItem('URLRoomName');
  const { getToken, isFetching, error, setError } = useAppState();
  const [roomName, setRoomName] = useState<string>('');
  const [name, setName] = useState<string>('');
  const [open, setOpen] = React.useState(false);

  const handleClick = ()  => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (URLRoomName) {
      setRoomName(URLRoomName);
    }
  }, [URLRoomName]);

  const handleNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const handleSubmit = (event:any) => {
    event.preventDefault();
    // If this app is deployed as a twilio function, don't change the URL beacuse routing isn't supported.
    // if (!window.location.origin.includes('twil.io')) {
    //   window.history.replaceState(null, '', window.encodeURI(`/room/${roomName}`));
    // }
    getToken(name, roomName).then((token: any) => {
      if(token === ""){
        handleClick();
        return;
      }
        window.sessionStorage.setItem('isConnected', "N");
        window.sessionStorage.setItem('twilioToken', token);
        window.sessionStorage.removeItem('URLRoomName')
        window.sessionStorage.setItem('roomName', roomName);
        window.location.replace('/room');
    });
  };
  return (
    <div className="pageWrapper">
      <Snackbar className="error-msg" 
            anchorOrigin={{ vertical: "top", horizontal: "center" }} 
            open={open} 
            autoHideDuration={5000} 
            onClose={handleClose} 
            message="The call has not yet started. Please try again later."/>
    <div className="container">
       <div className="row">
       <div className="col-12 text-center">
       <header className="header">
          <div className="logo">
             <img src={logoImage} width="95" />
            </div>
        </header>
       </div>
       </div>
        <section className="content">
           <div className="row">
             <div className="col-lg-6 m-auto col-12">
                <div className="login-block">
                  <h1>You have been invited to a call. Please Enter your name and tap Join Call.</h1>
                  <div className="room-detail">
                     <h2>ROOM</h2>
                     <h3>{URLRoomName}</h3>
                  </div>
                  <div className="formRow">
                   <input type="text" className="textbox" onChange={handleNameChange} placeholder="Name" />
                 </div>
                 <div className="button-action">
                   <button disabled={(name === '' || roomName === '' || isFetching)? true : false} className="joinbtn" onClick={handleSubmit}>{(isFetching) && <CircularProgress className="loading-spinner"/>}Join Call </button>
                 </div>
                </div>
                </div>
           </div>
           <div style={{display: "none"}}>
           <VideoProvider options={connectionOptions} onError={setError}>
            <LocalVideoPreview /> 
            </VideoProvider>
           </div>
        </section>
       
    </div>
    </div>

  );
}
